import { abs, ALLOW_INDEX, LOGO } from "@/lib/seo";

export const Seo = ({ title, description, path = "/", image, type = "website", jsonLd = [], noindex = false }) => {
  const url = abs(path);
  const img = abs(image || LOGO);
  const robots = !ALLOW_INDEX || noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large";
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={robots} />
      <meta property="og:site_name" content="SHADC Dispensary" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd.filter(Boolean).map((d, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(d) }} />
      ))}
    </>
  );
};
